import { SelectOption } from "Components/molecule/inputs/select-input";
import Employee from "models/employee";
import { EmploymentStatuses } from "models/employment-status";
import EmployeeUtility from "utils/models/employee-utility";

class DocumentGeneratorUtility {

    /**
     * The employee endpoints only return active people, so a doc saved against someone who has
     * since gone inactive has no matching option. Add that person back, disabled, so the saved
     * value still displays but cannot be picked again.
     */
    static employeeOptions(
        employees: Employee[],
        selected: Employee | null | undefined,
        placeholder: string
    ): SelectOption[] {
        const options: SelectOption[] = [
            { value: '', label: placeholder, disabled: false },
            ...employees.map(e => ({ value: e.id, label: EmployeeUtility.fullName(e), disabled: false }))
        ];

        if (selected && !employees.some(e => e.id === selected.id)) {
            options.push({
                value: selected.id,
                label: EmployeeUtility.fullName(selected),
                disabled: selected.employeeStatus?.description !== EmploymentStatuses.ACTIVE
            });
        }

        return options;
    }
}

export default DocumentGeneratorUtility;
